// extracted by mini-css-extract-plugin
export default {"main":"Footer_main__ETO+F","container":"Footer_container__R7sXj","heading":"Footer_heading__0CJ+E","text":"Footer_text__27sON"};